export default __webpack_public_path__ + "static/media/Landing_Journey_Mobile.c1be909d.png";